module.exports = __webpack_public_path__ + "static/img/layer2.2bd77ac8.png";